import { Component, Prop, Vue } from 'vue-property-decorator';

import AdvTaglessHomeCornerMark from '@/components/adv-components/adv-tagless-home-corner-mark';
import { TriangleFill12 } from '@hb/coffee-icons';
import platform from '@/shared/utils/platform';
import style from './index.module.scss';

@Component
export default class TaglessButton extends Vue {
   // 按钮展示的文案内容
   @Prop({
     type: String,
     default: '',
   }) readonly buttonName!: string;

   // 是否显示动态效果
   @Prop({
     type: Boolean,
     default: '',
   }) readonly isAnimateBtn!: boolean;

   private emitCreditAmount(e:Event) {
     this.$emit('emitClick', e);
   }

   private get homeClassName() {
     return platform.isHelloApp ? 'home-card' : 'home-card-noNav';
   }

   private render() {
     return (
      <div class={[style['apply-button'], this.isAnimateBtn && style['animate-btn']]}
            onClick={this.emitCreditAmount.bind(this)}>
            <AdvTaglessHomeCornerMark customClassName={style.homeCornerMark} />
            <span>{this.buttonName}</span>
            <TriangleFill12
              class={style.commonArrowTriangleFill}
            />
      </div>
     );
   }
}
